import angular from 'angular';
import booksMenu from '../../menu/Menu';

export default angular
  .module('recordsReport', [booksMenu])
  .controller('recordsReportController', recordsReportController)
  .name;

/* @ngInject */ function recordsReportController($scope, BooksSvc, SERVER, BusyScreen, Session) {
  var endDate = new Date();
  var startDate = new Date('1900-01-01T07:00:00.000Z');

  /*-----------------------------------------------------------*/
  /* Control object for resetting the entity to "All Entities" */
  /*-----------------------------------------------------------*/
  $scope.resetEntity = {};
  $scope.reportPage = Session.getSessionURL('/RecordsReport.aspx');

  var e = new Date('1900-01-01T07:00:00.000Z');

  /*-----------------------------------------------------------*/
  /* Control object for resetting the entity to "All Entities" */
  /*-----------------------------------------------------------*/
  $scope.resetEntity = {};

  /*---------------------*/
  /* Sets default values */
  /*---------------------*/
  $scope.req = {
    reportFormat: 'PDF',
    categoryID: 0, // Category
    itemID: 0, // Record
    groupID: 0, // Group
    endDate: endDate // Expires On date
  };
  $scope.data = { date: true };

  /*---------------------------------*/
  /* Resets values to default values */
  /*---------------------------------*/
  $scope.resetFilters = function () {
    $scope.req = {
      reportFormat: $scope.req.reportFormat,
      categoryID: 0, // Category
      itemID: 0, // Record
      groupID: 0, // Group
      endDate: endDate // Expires On date
    };
    $scope.resetEntity.reset();
    $scope.data = { date: true };
  };

  /*-----------------------------------------------------*/
  /* Watches data.date and sets the req.startDate to     */
  /* the current date when the "current records box" is  */
  /* checked and sets it to January 1900 when unchecked. */
  /*-----------------------------------------------------*/
  $scope.$watch('data.date', function (checked) {
    checked
      ? ($scope.req.startDate = endDate)
      : ($scope.req.startDate = startDate);
  });

  /*-------------------*/
  /* Load initial data */
  /*-------------------*/
  BooksSvc.getOrganization().then(function (resp) {
    $scope.org = resp.data;

    BooksSvc.getEntityGroupList(
      [
        SERVER.BooksDBConstants.ET_CLUB,
        SERVER.BooksDBConstants.ET_GROUP
      ].join(',')
    ).then(function (resp) {
      var groups = resp.data;
      $scope.groups = [{ id: 0, fullName: 'All Groups' }].concat(groups);

      BooksSvc.getItemList(SERVER.BooksDBConstants.IT_RECORDS).then(
        function (resp) {
          var itemsList = resp.data;

          /*--------------------------------------------------*/
          /* Creates a new categories array from the items    */
          /* array to filter the item typeahead based on the  */
          /* category selected in the Item Category typeahead */
          /*--------------------------------------------------*/
          var catIDs = [];
          var categories = [];
          for (var i = 0; i < resp.data.length; i++)
            if (catIDs.indexOf(resp.data[i].categoryID) == -1) {
              catIDs.push(resp.data[i].categoryID);
              categories.push({
                categoryID: resp.data[i].categoryID,
                category: resp.data[i].category
              });
            }
          $scope.categories = [
            { categoryID: 0, category: 'All Categories' }
          ].concat(categories);

          resp.data.sort(function (a, b) {
            return a.category
              .toLowerCase()
              .localeCompare(b.category.toLowerCase());
          });

          /*------------------------------------------------------------*/
          /* Watches the req.categoryID for changes and updates the     */
          /* product dropdown based on the categoryID selected and sets */
          /* the data.products to null upon any change to the category. */
          /*------------------------------------------------------------*/
          $scope.$watch('req.categoryID', function (category) {
            $scope.items = [];
            if (category) {
              for (var j = 0; j < itemsList.length; j++) {
                if (itemsList[j].categoryID == category) {
                  $scope.items = [
                    { id: 0, shortDescription: 'All Records' }
                  ].concat(itemsList[j]);
                  $scope.data.products = null;
                }
              }
            } else if (!category) {
              $scope.items = [
                { id: 0, shortDescription: 'All Records' }
              ].concat(resp.data);
              $scope.data.products = null;
            }
            return '';
          });
        }
      );
    });
    BusyScreen.setBusy(false);
  });
}